import { useEffect, useState } from 'react';

import { selectCustomer } from '@jane/monolith/customer/redux/customer';
import { useCustomerSelector } from '@jane/monolith/customer/selectors';
import { LogInModal } from '@jane/shared-ecomm/components';
import { useAuthentication } from '@jane/shared-ecomm/providers';

export const LoginModal = () => {
  const { authenticated: isLoggedIn } = useCustomerSelector(selectCustomer);
  const { apple, errors, google, login, logOut, register, resetPassword } =
    useAuthentication();
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) {
      setShowLoginModal(true);
    } else {
      setShowLoginModal(false);
    }
  }, [isLoggedIn]);

  return (
    <LogInModal
      errors={errors}
      location="header"
      logOut={logOut}
      onAppleClick={apple.onClick}
      onCreateAccountSubmit={register}
      onForgotPasswordSubmit={resetPassword}
      onGoogleClick={google.onClick}
      onRequestClose={() => setShowLoginModal(false)}
      onSignInSubmit={login}
      open={showLoginModal}
      showAppleLogin={apple.showLogin}
      showGoogleLogin={google.showLogin}
    />
  );
};
